var React = require('react');

function AnnounceLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23 43.03a1 1 0 01-.44-.1A15.3 15.3 0 0114 29.14V11.83a1 1 0 012 0v17.31a13.29 13.29 0 007.45 12 1 1 0 01-.45 1.9v-.01z","key":0}),React.createElement("path",{"d":"M41 36.06a3 3 0 01-1.26-.28C32.99 32.65 25.34 29.1 9 29.03H7a7 7 0 01-7-7v-4a7 7 0 017-7h2c16.34-.07 24-3.62 30.74-6.75A3 3 0 0144 7v26.06a2.9 2.9 0 01-.28 1.26A3 3 0 0141 36.06zM41 6a1 1 0 00-.43.09c-8.38 3.89-16 6.87-31.57 6.94H7a5 5 0 00-5 5v4a5 5 0 005 5h2c15.57.07 23.2 3.05 31.57 6.94a1 1 0 001.42-.91V7a1 1 0 00-1-1H41z","key":1}),React.createElement("path",{"d":"M44 25.03h-1a1 1 0 010-2h1a2 2 0 002-2v-2a2 2 0 00-2-2h-1a1 1 0 010-2h1a4 4 0 014 4v2a4 4 0 01-4 4z","key":2})]);
}

AnnounceLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = AnnounceLight;

AnnounceLight.default = AnnounceLight;
